import { APIClient } from 'api/hooks/use-clients';
import Button from 'components/button';
import { Select } from 'components/select';
import { FavouritesType, UsersType } from 'lib/dictionary';
import { EFavoritesType, ISelectItem } from 'lib/types';
import { useState } from 'react';
import styles from './styles.module.scss';
import useBoundStore from 'store';
import useUserList from 'api/hooks/use-users-list';
import useCopyFavoriteList from 'api/hooks/use-favorite-list-copy';

interface ICopyFavoriteListForm {
  type: EFavoritesType;
  title: string;
  onClose: () => void;
  id: number;
  refetchList: () => void;
}

type TCopyTo = 'self' | 'other';

const CopyFavoriteListForm = ({ title, type, onClose, refetchList, id }: ICopyFavoriteListForm) => {
  const user = useBoundStore((s) => s.user);
  const [self, setSelf] = useState<TCopyTo>('self');
  const { users, isLoading } = useUserList();
  const [clientId, setClientIds] = useState<number>(0);

  const { isMutating, error, trigger } = useCopyFavoriteList(id);

  const handleCopy = async () => {
    if (id) {
      if (self === 'other') {
        await trigger({ userId: clientId, title });
      } else {
        user?.id && (await trigger({ userId: user?.id, title }));
      }
      onClose();
      refetchList();
    }
  };

  const handleChange = (value: number) => {
    setClientIds(value);
  };

  const getName = (client: APIClient) => {
    const firstName = client?.fullname?.firstName ? client?.fullname?.firstName : '';
    const secondName = client?.fullname?.lastName ? client?.fullname?.lastName : '';
    return firstName + ' ' + secondName;
  };

  const menuArrayOptions: ISelectItem[] = users.map((users) => ({
    key: users.id,
    label: getName(users),
    note: users.phone + ' ' + UsersType.label(users.type),
  }));

  return (
    <div className={styles.container}>
      <div className={styles.title}>{`${FavouritesType.label(type)} список '${title}'`}</div>

      <div className={styles.select}>
        <Select
          size='lg'
          label={'Себе/Другим'}
          selected={self}
          multiple={false}
          onSelect={(value: TCopyTo) => setSelf(value)}
          menuArray={[
            { key: 'self', label: 'Себе' },
            { key: 'other', label: 'Дргим' },
          ]}
        />
      </div>

      {self === 'other' && (
        <div className={styles.select}>
          <Select
            size='lg'
            label={'Укажите пользователя'}
            search
            selected={clientId}
            multiple={false}
            onSelect={(value: number) => {
              handleChange(value);
            }}
            menuArray={menuArrayOptions}
          />
        </div>
      )}

      <div className={styles.flexButton}>
        <Button variant='gray' onClick={onClose} label='Отменить' />
        <Button
          loading={isMutating}
          onClick={() => {
            handleCopy();
          }}
          label='Копировать'
        />
      </div>
    </div>
  );
};

export default CopyFavoriteListForm;
